export const STRINGS = {
  'sign_up.email_taken_line1': 'Unable to register. Please ',
  'sign_up.email_taken_line2': ' or use Forgot Password to recover access.',
  'sign_up.email_taken_button': ' SIGN IN',
};
